import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'

import { Loader } from 'rsuite'

import { AppStateType } from '../../bll/store'
import Disciplines from './disciplines'
import { clearDisciplines, getDisciplines } from '../../bll/rpd/rpdOperations'
import openNotification from '../_ui/notification'
import errorHandler from '../../bll/errorHandler'

const DisciplinesContainer = (props: any) => {
    const urlParams = useParams()

    const [isVisibleLoader, setIsVisibleLoader] = React.useState(false) // Видимость компоненты Loader

    React.useEffect(() => {
        setIsVisibleLoader(true)

        props.getDisciplines(urlParams.id).then((result: any) => {
            setIsVisibleLoader(false)

            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Направления подготовки...", 'УПС, что то пошло не так!', "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })

        return () => {
            props.clearDisciplines()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // Свойства передаваемые в компоненту
    const propsToComponent = {

    }

    return (
        <>
            {isVisibleLoader
                ? <div style={{ height: "100%", position: "relative" }}><Loader center size="md" content="Загрузка данных..." vertical /> </div>
                : <Disciplines {...props} {...propsToComponent} />
            }
        </>
    )
}

let mapState = (state: AppStateType) => {
    return {
        msg: state.msg,
        disciplinesList: state.rpd.disciplinesList,
    }
}

export default compose(connect(mapState, { getDisciplines, clearDisciplines }))(DisciplinesContainer)